export const SELECTED_PLANT = 'SELECTED_PLANT';
export const SELECTED_LOCATION = 'SELECTED_LOCATION';
export const SELECTED_RESOURCE = 'SELECTED_RESOURCE';
export const ACTIVE_TAB = 'ACTIVE_TAB';
export const RESOURCE_QUEUE_SELECTED_ID = 'RESOURCE_QUEUE_SELECTED_ID';
export const SELECTION_LIST_SELECTED_ID = 'SELECTION_LIST_SELECTED_ID';
